module.exports = __webpack_public_path__ + "img/logo.06fcb415.jpg";